<template>
	<div class="bottom">
		<div class="footer">
			<ul class="bottom_navs">
				<router-link to="Home" tag="li">首页</router-link>
				<!-- <router-link to="Technology_Services" tag="li">技术与服务</router-link> -->
				<router-link to="Big_Data" tag="li">保险行业赋能</router-link>
				<router-link to="About_Us" tag="li">关于我们</router-link>
				<router-link to="Contact_Us" tag="li">联系我们</router-link>
			</ul>

			<p class="text">免费热线：（0512）68859088&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;邮箱：service@dawntech-info.com</p>
			<p class="text">地址： 苏州市姑苏区朱家湾街8号3幢1202室</p>
			<p class="text"><a target="_blank" href="https://beian.miit.gov.cn/">{{siteNo}}</a></p>
			<p class="flex text"> <img class="jh" src="@/assets/jh-icon.png"><a target="_blank" href="https://beian.mps.gov.cn/#/query/webSearch">{{siteNo1}}</a></p>
			<p class="text">Copyright © 2021-2030 {{website}} All Rights Reserved 江苏道泰信息技术有限公司版权所有</p>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Footer',
	data() {
		return {}
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss" type="text/scss">
	.bottom {
		width: 100%;
		height: 200px;
		border-top: 1px solid #ccc;

		.footer {
			width: 1200px;
			height: 200px;
			margin: 0 auto;
			text-align: center;

			.bottom_navs {
				display: inline-block;
				margin: 36px auto;

				li {
					list-style: none;
					float: left;
					margin-right: 70px;
					height: 23px;
					line-height: 23px;
					font-size: 18px;
					font-family: PingFangSC-Medium;
					font-weight: 500;
					color: rgba(0, 0, 0, 1);
					cursor: pointer;

					&:hover {
						font-size: 28px;
						color: #4196ff;
					}
				}
			}
            .flex {
				display: flex;
				justify-content: center;
				align-items: center;
			}

			.jh {
				margin-right: 2px;
				width: 16px;
			}
			.text {
				height: 20px;
				font-size: 16px;
				font-family: PingFangSC-Medium;
				font-weight: 500;
				color: rgba(0, 0, 0, 1);
				margin: 0 0 13px;

				a {
					text-decoration: none;
					color: rgba(0, 0, 0, 1);
				}

				a:hover {
					color: #4196ff !important;
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue